<div class="row" id="fr" #fr>
  <div class="col-md-12">
  </div>
</div>
<div class="row tabs-cont hide-nav-link" #tabsCont>
  <div class="col-md-12 h-100">
    <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false">
      <ngb-tab title="Pregled" id="tbList"
       [disabled]="tabsContainerService.IsListTabDisabled">       
        <ng-template ngbTabContent>  
          <yt-fw-please-wait [ShowLoader]="loading"></yt-fw-please-wait>              
          <filter-with-komitent
            (FilterApplied)="applayFilter($event)"
            (CheckInputDocumentAndRefreshStatusClicked)="checkInputDocumentAndRefreshStatus($event)"
            #filterFak>
          </filter-with-komitent>
          <div class="row">
            <div class="col-md-6">
              <yt-fw-default-list-tabs
               [CondensedTable]="true"
               (TableContextMenuItemClicked)="ContextMenuClicked($event)"
               (MainItemSelected)="SelektovanRacun($event)"
               (TableContextMenuClicked)="ContextMenuOfTableClicked($event)"
                #defaultList
              ></yt-fw-default-list-tabs>      
            </div>
          <div class="col-md-6">
  <div class="d-flex align-items-start mt-3 ml-3">
    <button type="button"
            (click)="printPDF()"
            class="btn btn-primary mr-2"
            ngbTooltip="{{'ULAZNIDOKUMENTDOBAVLJACA.PRINTPDF.ACTION' | translate}}"
            container="body">
      <span class="fa fa-fw fa-print"></span>
    </button>

    <button type="button"
            (click)="PreuzmiPriloge()"
            class="btn btn-primary"
            ngbTooltip="{{'ULAZNIDOKUMENTDOBAVLJACA.PREUZMIPRILOGE.ACTION' | translate}}"
            container="body">
      <span class="fa fa-solid fa-download"></span>
    </button>
  </div>

  <div class="mt-2">
    <pdf-viewer [src]="pdfSrc" style="display:block;"></pdf-viewer>
  </div>
</div>

          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</div>
